export default __webpack_public_path__ + "static/media/logoHyper.203cf9e8.png";